import { render, staticRenderFns } from "./FieldAndValue.vue?vue&type=template&id=baed9330&scoped=true&"
import script from "./FieldAndValue.vue?vue&type=script&lang=ts&"
export * from "./FieldAndValue.vue?vue&type=script&lang=ts&"
import style0 from "./FieldAndValue.vue?vue&type=style&index=0&id=baed9330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed9330",
  null
  
)

export default component.exports